import React from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  CardMedia, 
  Chip, 
  Divider, 
  Stack, 
  Typography 
} from '@mui/material';
import IngredientsList from './IngredientsList';
import MarkdownRenderer from '../../components/MarkdownRenderer';

const ViewMode = React.memo(({ recipe }) => {
  return (
    <Stack spacing={3}>
      {/* Recipe Image */}
      <Card elevation={3}>
        <CardMedia
          component="img"
          height="300"
          image={recipe?.picture}
          alt={recipe?.title}
        />
      </Card>

      {/* Video Section */}
      {recipe?.videoUrl && (
        <Card elevation={3}>
          <CardContent>
            <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
                src={recipe.videoUrl}
                title="Recipe Video"
                frameBorder="0"
                allowFullScreen
              />
            </Box>
          </CardContent>
        </Card>
      )}

      {/* Recipe Details */}
      <Card elevation={3}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            {recipe?.title}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            By {recipe?.author}
          </Typography>
          <Box sx={{ my: 2 }}>
            {recipe?.tags.map((tag) => (
              <Chip
                key={tag}
                label={tag}
                sx={{ mr: 1, mb: 1 }}
              />
            ))}
          </Box>
          <Divider sx={{ my: 2 }} />
          <IngredientsList ingredients={recipe?.ingredients} />
          <MarkdownRenderer content={recipe?.recipeContent} />
        </CardContent>
      </Card>
    </Stack>
  );
});

export default ViewMode;